<template>
  <div class="ui dimmer modals page visible active">
    <div class="ui tiny modal active visible">
      <i
        class="close icon"
        aria-hidden="true"
        @click="$emit('close')"
      />

      <div class="ui icon header">
        <i
          :class="iconClass"
          aria-hidden="true"
        />
        <br>

        <!-- DELETE -->
        <template v-if="isDeleteAction">
          Êtes-vous sûr de vouloir effacer
          <span v-if="totalFeaturesCount === 1">
            un signalement&nbsp;?
          </span>
          <span v-else-if="totalFeaturesCount > 1">
            ces {{ totalFeaturesCount }} signalements&nbsp;?
          </span>
          <span v-else>
            les signalements sélectionnés&nbsp;?
          </span>
        </template>

        <!-- UPDATE STATUS -->
        <template v-else-if="isUpdateStatusAction">
          Êtes-vous sûr de vouloir modifier le statut
          <span v-if="totalFeaturesCount === 1">
            du signalement&nbsp;?
          </span>
          <span v-else-if="totalFeaturesCount > 1">
            de ces {{ totalFeaturesCount }} signalements&nbsp;?
          </span>
          <span v-else>
            des signalements sélectionnés&nbsp;?
          </span>
        </template>
      </div>

      <div class="content">
        <template v-if="isDeleteAction">
          Seuls ceux que vous êtes autorisé à supprimer seront réellement effacés.
        </template>

        <template v-else-if="isUpdateStatusAction">
          Seuls les signalements pour lesquels vous avez les droits seront modifiés.
        </template>
      </div>

      <div class="actions">
        <button
          v-if="isDeleteAction"
          type="button"
          class="ui primary compact button"
          @click="$emit('confirm-delete')"
        >
          Confirmer la suppression
        </button>

        <button
          v-else-if="isUpdateStatusAction"
          type="button"
          class="ui green compact button"
          @click="$emit('confirm-update-status')"
        >
          Confirmer la modification
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ConfirmBulkActionModal',

  props: {
    action: {
      type: String,
      required: true,
    },
    totalFeaturesCount: {
      type: Number,
      required: true,
    },
  },

  computed: {
    isDeleteAction() {
      return this.action === 'delete';
    },

    isUpdateStatusAction() {
      return this.action === 'update-status';
    },

    iconClass() {
      return this.isDeleteAction
        ? 'trash alternate icon'
        : 'exchange alternate icon';
    },
  },
};

</script>
